// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".shows-filter{border:1px solid;opacity:0;transition:opacity .25s ease}.shows-filter.-open{opacity:1;transition-delay:.25s}.shows-filter_inner{display:flex;flex-wrap:wrap;justify-content:flex-end;width:100%;padding:16px}@media(min-width:640px){.shows-filter_inner{padding:calc(1.42857vw + 6.85714px)}}@media(min-width:1200px){.shows-filter_inner{padding:24px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
